import { FormSetting } from 'scripts/type'
import { getStorageKey, Storage } from 'scripts/utils/index'

export function setStorageFormSetting(setting: FormSetting, token: string) {
  Storage.setItem(getStorageKey('formSetting', token), setting)
}

export function getStorageFormSetting(token: string) {
  return Storage.getItem(getStorageKey('formSetting', token))
}
